import type React from "react";
import styled from "styled-components";

export interface StepProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

const IconCircle = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgb(255, 255, 255)",
  borderRadius: "50%",
  color: "rgb(80, 70, 229)",
  width: 64,
  minWidth: 64,
  height: 64,
  fontSize: 24,
  boxShadow: "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
}));

export default IconCircle;
